import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiTasksTaskNotFoundError } from '@/core/error/transport/tmApiTasksTaskNotFoundError'

export const tasksTaskNotFoundErrorRule: CustomErrorRule = {
  klass: TmApiTasksTaskNotFoundError,
  predicateFn: (error) => {
    return error.response.data.message.includes('Task object not found')
  },
}
